module.exports = __webpack_public_path__ + "static/media/corpu_doc2.0e619554.JPG";